const handleMultipleSelects = () => {
	const $select = $('.js-select-multiple');

	$select.each(function(index, el) {
		const $this = $(this);
		const placeholder = $this.data('placeholder');

		$this.searchableOptionList({
			showSelectAll: false,
			showSelectionBelowList: true,
			texts: {
		        noItemsAvailable: 'Go on, nothing to see here',
		        selectAll: 'Get em all',
		        selectNone: 'Nah',
		        quickDelete: '',
		        searchplaceholder: placeholder
		    },
		    events: {
		    	onOpen: function(sol, items)	{
		    		const $select = $('.select-options');

		    		$select.each(function(index, el) {
		    			const $this = $(this);

		            	const $containerWitdh = $this.find('.sol-container').width();
		            	const $options = $this.find('.sol-selection-container');

						$options.css({
							width: $containerWitdh
						});
		    		});
	            },
			    onScroll: function() {
	            	let posY = this.$input.offset().top - this.config.scrollTarget.scrollTop() + this.$input.outerHeight(),
	                    selectionContainerWidth = this.$innerContainer.outerWidth(false) - parseInt(this.$selectionContainer.css('border-left-width'), 10) - parseInt(this.$selectionContainer.css('border-right-width'), 10);

					this.$selectionContainer
	                    .css('top', Math.floor(posY))
		    	}
            },
		});
	});
};

handleMultipleSelects();
